const FALLBACK_PATH = '/practice-members';

/**
 * `returnUrl` is attacker-controllable via the query string. Only follow it
 * when it names this app's own origin; otherwise fall back.
 */
export function getSafeReturnPath(returnUrl?: string): string {
    if (!returnUrl) return FALLBACK_PATH;

    try {
        const url = new URL(returnUrl);
        if (url.origin !== window.location.origin) return FALLBACK_PATH;
        // `//host` is same-origin as a URL but a protocol-relative reference as a bare path.
        if (url.pathname.startsWith('//')) return FALLBACK_PATH;
        // A returnUrl chained back to /sign-in would re-run this same redirect on arrival,
        // looping forever between two already-signed-in visits.
        if (url.pathname === '/sign-in') return FALLBACK_PATH;
        return `${url.pathname}${url.search}${url.hash}`;
    } catch {
        return FALLBACK_PATH;
    }
}
